import { formatUSD } from '../../helpers';
import AnalyticsSmallCard from './AnalyticsSmallCard';
// import useAnalytics from '../../hooks/analytics/useAnalytics';
import useMockAnalytics from '../../hooks/analytics/useMockAnalytics';

const TotalTrades = () => {
    const { analytics, isLoading, defaultData } = useMockAnalytics();

    return (
        <AnalyticsSmallCard
            title='Total Trades'
            percentageDifference={
                analytics ? analytics.totalTrades.dailyDiffPercentage.toString() : '0'
            }
            amount={formatUSD(analytics?.totalTrades.currentValue.toString() || '0', {
                maxDecimals: 0,
                currency: '',
            })}
            data={analytics?.totalTrades.historicalData ?? defaultData}
            isLoading={isLoading}
        />
    );
};

export default TotalTrades;
